// removed by extract-text-webpack-plugin
module.exports = {"skew":"dh-kult-hnio-skew","skew--top":"dh-kult-hnio-skew--top","skew--bottom":"dh-kult-hnio-skew--bottom"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Skew/index.css
// module id = 225
// module chunks = 0